import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux'

import { formatDate } from 'Util';
import ChartTradeSignal from 'Component/chart/trade_signal';
import SubHead from 'Component/title/sub_head';
import renderingGuide from 'Component/title/guide_content';

const TradeSignal = () => {

  const { tickerDetail } = useSelector((state) => state.stock);
  const [data, setData] = useState();

  function renderingComment(ts) {
    if (ts) {
      const val = ts.COMMENT;
      if (val === 1) {
        return (
          <dd><strong className="txt_red">상승</strong> 하고 있습니다.</dd>
        )
      } else if (val === -1) {
        return (
          <dd><strong className="txt_blue">하락</strong> 하고 있습니다.</dd>
        )
      } else if (val === 0) {
        return (
          <dd><strong className="txt_gray">횡보</strong> 하고 있습니다.</dd>
        )
      }
    } else {
      return (
        <dd><strong className="txt_gray">학습</strong> 하고 있습니다.</dd>
      )
    }
  }

  function renderingSignal(val) {

    let data;
      
    if (val === -6) {
      data = ['full', 'full', 'full', '', '', '', ''];
    } else if (val === -5) {
      data = ['half', 'full', 'full', '', '', '', ''];
    } else if (val === -4) {
      data = ['', 'full', 'full', '', '', '', ''];
    } else if (val === -3) {
      data = ['', 'half', 'full', '', '', '', ''];
    } else if (val === -2) {
      data = ['', '', 'full', '', '', '', ''];
    } else if (val === -1) {
      data = ['', '', 'half', '', '', '', ''];
    } else if (val === 0) {
      data = ['', '', '', '', '', '', ''];
    } else if (val === 1) {
      data = ['', '', '', '', 'half', '', ''];
    } else if (val === 2) {
      data = ['', '', '', '', 'full', '', ''];
    } else if (val === 3) {
      data = ['', '', '', '', 'full', 'half', ''];
    } else if (val === 4) {
      data = ['', '', '', '', 'full', 'full', ''];
    } else if (val === 5) {
      data = ['', '', '', '', 'full', 'full', 'half'];
    } else if (val === 6) {
      data = ['', '', '', '', 'full', 'full', 'full'];
    }

    return (
      <div className="bar">
        { data.map((item, index) => {
            if (index <= 2) {
              return (
                <i key={index} className={"bar_circle bar_blue " + item}></i>
              )
            } else if (index === 3) {
              return (
                <i key={index} className="bar_div"></i>
              )
            } else {
              return (
                <i key={index} className={"bar_circle bar_red " + item}></i>
              )
            }
          })
        }
      </div>
    )
  }

  useEffect(() => {
    if (tickerDetail && tickerDetail.ts_history && tickerDetail.ts_history.length > 0) {
      const x = [];
      const y1 = [];
      const y2 = [];
      const y3 = [];

      let list = [...tickerDetail.ts_history];
      list = list.reverse();
      list.forEach(element => {
        x.push(formatDate(element.TRD_DT));
        if (element.SIGNAL > 0) {
          y1.push(element.SIGNAL);
          y2.push(0);
        } else if (element.SIGNAL < 0) {
          y1.push(0);
          y2.push(element.SIGNAL);
        } else {
          y1.push(0);
          y1.push(0);
        }
        y3.push(element.PRICE);
      });
      
      setData({
        x: x,
        y1: y1,
        y2: y2,
        y3: y3
      })
    } else {
      setData(null);
    }

  }, [tickerDetail])

	return (
    <>
      { tickerDetail &&
        <div className="content5">
          <SubHead guideType="stock" guide="ts">
            <img src="/static/images/icon_graph3.png" alt="" />
            <span>토브스탁 단기 매매시그널</span>
          </SubHead>
          
          <div className="cont">
            { tickerDetail.ts
              ?
                <div className="bars">
                  <div className="txt txt_blue">부정</div>
                  {renderingSignal(tickerDetail.ts.SIGNAL)}
                  <div className="txt txt_red">긍정</div>
                </div>
              :
                <div className="bars bars_none">
                  <div className="txt">부정</div>
                  <div className="bar">
                      <i className="bar_circle bar_blue"></i>
                      <i className="bar_circle bar_blue"></i>
                      <i className="bar_circle bar_blue"></i>
                      <i className="bar_div"></i>
                      <i className="bar_circle bar_red"></i>
                      <i className="bar_circle bar_red"></i>
                      <i className="bar_circle bar_red"></i>
                  </div>
                  <div className="txt">긍정</div>
                </div>
            }

            { data
              ?
                <div className="chart">
                  <ChartTradeSignal data={data} title={['','','주가']} />
                </div>
              :
                <div className="chart chart_none">
                  <div className="none_ico"><img src="/static/images/icon_ai.svg" alt="" /></div>
                  <div className="none_txt txt_gray">AI 데이터 학습 중입니다.</div>
                </div>
            }
        
            <div className="text">
              <dl>
                <dt><img src="/static/images/icon_heart2.svg" alt="" /> 매매시그널 :</dt>
                {renderingComment(tickerDetail.ts)}
              </dl>
            </div>
            {/* 설명: 매매시그널 영역 바로 아래 같은 박스 내부에 연한 구분선 및 설명 추가 */}
              <div style={{marginTop:14}}>
                <div style={{marginTop:12, color:'#666', lineHeight:1.8}}>
                  <div style={{fontWeight:700, color:'#333', marginBottom:0, fontSize:16}}>단기 매매시그널</div>
                  <div style={{fontWeight:600, fontSize:14}}>※ MACD, 볼린저밴드, ADR 등 다양한 보조지표를 활용하여 기업의 단기적인 매매 타이밍을 분석하는 도구입니다.</div>
                  <div style={{fontWeight:600, fontSize:14}}>※ '긍정'과 '부정'의 방향성을 활용하여 매매 시점을 보조합니다.</div>
                </div>
              </div>
          </div>
        </div>
      }
    </>
  );
}

export default TradeSignal;
